// pages/GuildCreation.js (이모지 선택만 가능하도록 수정)
import React, { useState } from "react";
import { guildDataService } from "./GuildDataService";

const SPORTS = ["탁구", "배드민턴", "테니스", "볼링", "축구", "농구"];

// 기본 길드 로고 이모지 옵션 (스포츠 관련 추가)
const DEFAULT_GUILD_LOGOS = [
  // 스포츠 관련 이모지
  { id: 'table_tennis', emoji: '🏓', name: '탁구', color: '#ef4444' },
  { id: 'badminton', emoji: '🏸', name: '배드민턴', color: '#10b981' },
  { id: 'tennis', emoji: '🎾', name: '테니스', color: '#f59e0b' },
  { id: 'bowling', emoji: '🎳', name: '볼링', color: '#8b5cf6' },
  { id: 'soccer', emoji: '⚽', name: '축구', color: '#06b6d4' },
  { id: 'basketball', emoji: '🏀', name: '농구', color: '#f97316' },
  { id: 'volleyball', emoji: '🏐', name: '배구', color: '#ec4899' },
  { id: 'baseball', emoji: '⚾', name: '야구', color: '#fbbf24' },
  { id: 'golf', emoji: '⛳', name: '골프', color: '#10b981' },
  { id: 'swimming', emoji: '🏊', name: '수영', color: '#06b6d4' },
  { id: 'running', emoji: '🏃', name: '달리기', color: '#ef4444' },
  { id: 'cycling', emoji: '🚴', name: '자전거', color: '#8b5cf6' },
  { id: 'weightlifting', emoji: '🏋️', name: '역도', color: '#f59e0b' },
  { id: 'boxing', emoji: '🥊', name: '복싱', color: '#dc2626' },
  { id: 'martial_arts', emoji: '🥋', name: '무술', color: '#7c3aed' },
  { id: 'yoga', emoji: '🧘', name: '요가', color: '#059669' },
  { id: 'dancing', emoji: '💃', name: '댄스', color: '#ec4899' },
  { id: 'skiing', emoji: '⛷️', name: '스키', color: '#06b6d4' },
  { id: 'snowboarding', emoji: '🏂', name: '스노보드', color: '#3b82f6' },
  { id: 'surfing', emoji: '🏄', name: '서핑', color: '#0891b2' },
  { id: 'climbing', emoji: '🧗', name: '클라이밍', color: '#f59e0b' },
  { id: 'archery', emoji: '🏹', name: '양궁', color: '#8b5cf6' },
  { id: 'fencing', emoji: '🤺', name: '펜싱', color: '#6366f1' },
  { id: 'hockey', emoji: '🏒', name: '하키', color: '#dc2626' },
  { id: 'rugby', emoji: '🏉', name: '럭비', color: '#f59e0b' },
  // 기존 이모지들
  { id: 'castle', emoji: '🏰', name: '성', color: '#667eea' },
  { id: 'shield', emoji: '🛡️', name: '방패', color: '#f093fb' },
  { id: 'crossed_swords', emoji: '⚔️', name: '검', color: '#ff6b6b' },
  { id: 'crown', emoji: '👑', name: '왕관', color: '#fbbf24' },
  { id: 'fire', emoji: '🔥', name: '불꽃', color: '#f59e0b' },
  { id: 'lightning', emoji: '⚡', name: '번개', color: '#8b5cf6' },
  { id: 'star', emoji: '⭐', name: '별', color: '#10b981' },
  { id: 'gem', emoji: '💎', name: '다이아몬드', color: '#06b6d4' },
  { id: 'trophy', emoji: '🏆', name: '트로피', color: '#f59e0b' },
  { id: 'rocket', emoji: '🚀', name: '로켓', color: '#3b82f6' },
  { id: 'phoenix', emoji: '🔮', name: '수정구', color: '#8b5cf6' },
  { id: 'dragon', emoji: '🐉', name: '드래곤', color: '#ef4444' },
  { id: 'heart', emoji: '❤️', name: '하트', color: '#ef4444' },
  { id: 'sun', emoji: '☀️', name: '태양', color: '#f59e0b' },
  { id: 'moon', emoji: '🌙', name: '달', color: '#8b5cf6' },
  { id: 'rainbow', emoji: '🌈', name: '무지개', color: '#06b6d4' },
  { id: 'clover', emoji: '🍀', name: '클로버', color: '#10b981' },
  { id: 'rose', emoji: '🌹', name: '장미', color: '#ef4444' },
  { id: 'diamond', emoji: '💠', name: '다이아몬드', color: '#06b6d4' },
  { id: 'sparkles', emoji: '✨', name: '반짝임', color: '#fbbf24' },
  { id: 'comet', emoji: '☄️', name: '혜성', color: '#8b5cf6' },
  { id: 'zap', emoji: '⚡', name: '번개', color: '#f59e0b' },
  { id: 'snowflake', emoji: '❄️', name: '눈송이', color: '#06b6d4' },
  { id: 'leaf', emoji: '🍃', name: '잎사귀', color: '#10b981' }
];

// 추천 해시태그 목록
const SUGGESTED_HASHTAGS = [
  // 실력 관련
  '초보환영', '고수모집', '중급자', '실력향상', '연습중심',
  // 분위기 관련
  '친목위주', '진지한게임', '재미있게', '열정적인', '차분한',
  // 활동 관련
  '매일모임', '주말활동', '저녁시간', '자유참여', '정기모임',
  // 목표 관련
  '랭킹상승', '대회참가', '기술연마', '함께성장', '꾸준히',
  // 지역 관련
  '서울', '경기', '인천', '부산', '대구', '광주', '대전', '울산',
  // 연령 관련
  '20대', '30대', '40대', '50대', '학생', '직장인',
  // 특별 테마
  '여성길드', '남성길드', '혼성길드', '가족길드', '동호회'
];

function GuildCreation({ currentUser, creating, setCreating, onGuildCreated, onMessage }) {
  const [newGuild, setNewGuild] = useState({ 
    name: "", 
    intro: "", 
    hashtags: [],
    sport: SPORTS[0],
    selectedDefaultLogo: null
  });
  const [uploading, setUploading] = useState(false);
  const [currentHashtag, setCurrentHashtag] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  // 해시태그 추가
  const addHashtag = (tag) => {
    const cleanTag = tag.replace('#', '').trim();
    if (cleanTag && !newGuild.hashtags.includes(cleanTag) && newGuild.hashtags.length < 10) {
      setNewGuild(prev => ({
        ...prev,
        hashtags: [...prev.hashtags, cleanTag]
      }));
      setCurrentHashtag('');
      setShowSuggestions(false);
    }
  };

  // 해시태그 제거
  const removeHashtag = (tagToRemove) => {
    setNewGuild(prev => ({
      ...prev,
      hashtags: prev.hashtags.filter(tag => tag !== tagToRemove)
    }));
  };

  // 해시태그 입력 처리
  const handleHashtagInput = (e) => {
    const value = e.target.value;
    if (e.key === 'Enter' && value.trim()) {
      e.preventDefault();
      addHashtag(value);
    } else if (e.key === 'Backspace' && !value && newGuild.hashtags.length > 0) {
      removeHashtag(newGuild.hashtags[newGuild.hashtags.length - 1]);
    } else {
      setCurrentHashtag(value);
      setShowSuggestions(value.length > 0);
    }
  };

  const filteredSuggestions = SUGGESTED_HASHTAGS.filter(tag => 
    tag.toLowerCase().includes(currentHashtag.toLowerCase()) &&
    !newGuild.hashtags.includes(tag)
  ).slice(0, 8);

  const handleCreateGuild = async () => {
    if (!newGuild.name.trim()) {
      onMessage("길드명을 입력해주세요.");
      return;
    }

    if (!newGuild.selectedDefaultLogo) {
      onMessage("길드 로고를 선택해주세요.");
      return;
    }

    try {
      setUploading(true);
      onMessage("길드 생성 중...");
      
      // 이모지 로고 URL 생성
      const logoUrl = `default_logo_${newGuild.selectedDefaultLogo.id}`;

      console.log("🏰 길드 생성 API 호출 시작");
      
      // 길드 생성 데이터 준비
      const guildData = {
        name: newGuild.name.trim(),
        intro: newGuild.intro.trim(),
        description: newGuild.intro.trim(),
        hashtags: newGuild.hashtags,
        sport: newGuild.sport,
        logoUrl,
        logoType: 'default',
        defaultLogoData: newGuild.selectedDefaultLogo,
        coverUrl: logoUrl // 호환성
      };

      // 길드 생성
      const result = await guildDataService.createGuild(
        guildData,
        currentUser.id,
        currentUser.nickname || currentUser.email || currentUser.id
      );

      console.log("✅ 길드 생성 성공:", result);
      
      onMessage("🎉 길드가 성공적으로 생성되었습니다!");
      setCreating(false);
      onGuildCreated(result);
      
    } catch (error) {
      console.error("❌ 길드 생성 실패:", error);
      onMessage("길드 생성에 실패했습니다. 다시 시도해주세요.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.8)",
      backdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      padding: 20
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 24,
        padding: 32,
        width: "100%",
        maxWidth: 600,
        maxHeight: "90vh",
        overflowY: "auto",
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
      }}>
        {/* 헤더 */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 32,
          paddingBottom: 20,
          borderBottom: "2px solid #f1f5f9"
        }}>
          <div>
            <h2 style={{
              fontSize: 28,
              fontWeight: 800,
              color: "#1e293b",
              margin: 0,
              marginBottom: 8
            }}>
              🏰 새 길드 만들기
            </h2>
            <p style={{
              fontSize: 16,
              color: "#64748b",
              margin: 0
            }}>
              나만의 길드를 만들어 멤버들과 함께 성장하세요
            </p>
          </div>
          <button
            onClick={() => setCreating(false)}
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "none",
              background: "#f1f5f9",
              color: "#64748b",
              fontSize: 18,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s"
            }}
            onMouseOver={(e) => {
              e.target.style.background = "#e2e8f0";
              e.target.style.color = "#475569";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "#f1f5f9";
              e.target.style.color = "#64748b";
            }}
          >
            ×
          </button>
        </div>

        {/* 길드명 입력 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: "block",
            fontSize: 16,
            fontWeight: 600,
            color: "#374151",
            marginBottom: 8
          }}>
            길드명 *
          </label>
          <input
            type="text"
            value={newGuild.name}
            onChange={(e) => setNewGuild(prev => ({ ...prev, name: e.target.value }))}
            placeholder="멋진 길드명을 입력하세요"
            maxLength={30}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: 16,
              border: "2px solid #e5e7eb",
              borderRadius: 12,
              background: "#f9fafb",
              transition: "all 0.2s",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#667eea";
              e.target.style.background = "#fff";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e5e7eb";
              e.target.style.background = "#f9fafb";
            }}
          />
          <div style={{
            fontSize: 12,
            color: "#6b7280",
            marginTop: 4,
            textAlign: "right"
          }}>
            {newGuild.name.length}/30
          </div>
        </div>

        {/* 종목 선택 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: "block",
            fontSize: 16,
            fontWeight: 600,
            color: "#374151",
            marginBottom: 8
          }}>
            주 종목 *
          </label>
          <select
            value={newGuild.sport}
            onChange={(e) => setNewGuild(prev => ({ ...prev, sport: e.target.value }))}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: 16,
              border: "2px solid #e5e7eb",
              borderRadius: 12,
              background: "#f9fafb",
              cursor: "pointer",
              boxSizing: "border-box"
            }}
          >
            {SPORTS.map(sport => (
              <option key={sport} value={sport}>{sport}</option>
            ))}
          </select>
        </div>

        {/* 로고 선택 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: "block",
            fontSize: 16,
            fontWeight: 600,
            color: "#374151",
            marginBottom: 8
          }}>
            길드 로고 *
          </label>
          
          {/* 선택된 로고 미리보기 */}
          {newGuild.selectedDefaultLogo && (
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              marginBottom: 16,
              padding: 16,
              background: "#f8fafc",
              borderRadius: 12,
              border: "2px solid #e2e8f0"
            }}>
              <div style={{
                width: 60,
                height: 60,
                borderRadius: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                background: `linear-gradient(135deg, ${newGuild.selectedDefaultLogo.color}20, ${newGuild.selectedDefaultLogo.color}10)`
              }}>
                {newGuild.selectedDefaultLogo.emoji}
              </div>
              <div>
                <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                  선택된 로고: {newGuild.selectedDefaultLogo.name}
                </p>
                <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>
                  이모지로 표현되는 길드 로고입니다
                </p>
              </div>
            </div>
          )}

          {/* 이모지 로고 선택 */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
            gap: 12,
            padding: 16,
            background: "#f8fafc",
            borderRadius: 12,
            border: "1px solid #e2e8f0",
            maxHeight: "300px",
            overflowY: "auto"
          }}>
            {DEFAULT_GUILD_LOGOS.map((logo) => (
              <button
                key={logo.id}
                onClick={() => setNewGuild(prev => ({ ...prev, selectedDefaultLogo: logo }))}
                style={{
                  position: "relative",
                  width: 80,
                  height: 80,
                  borderRadius: 16,
                  border: `3px solid ${newGuild.selectedDefaultLogo?.id === logo.id ? logo.color : 'transparent'}`,
                  background: `linear-gradient(135deg, ${logo.color}20, ${logo.color}10)`,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 32,
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => {
                  if (newGuild.selectedDefaultLogo?.id !== logo.id) {
                    e.currentTarget.style.border = `3px solid ${logo.color}60`;
                  }
                }}
                onMouseOut={(e) => {
                  if (newGuild.selectedDefaultLogo?.id !== logo.id) {
                    e.currentTarget.style.border = '3px solid transparent';
                  }
                }}
              >
                {logo.emoji}
                {newGuild.selectedDefaultLogo?.id === logo.id && (
                  <div style={{
                    position: "absolute",
                    top: -8,
                    right: -8,
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: logo.color,
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12
                  }}>
                    ✓
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* 길드 소개 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: "block",
            fontSize: 16,
            fontWeight: 600,
            color: "#374151",
            marginBottom: 8
          }}>
            길드 소개
          </label>
          <textarea
            value={newGuild.intro}
            onChange={(e) => setNewGuild(prev => ({ ...prev, intro: e.target.value }))}
            placeholder="길드의 목표, 분위기, 활동 방식 등을 자유롭게 소개해주세요"
            maxLength={500}
            rows={4}
            style={{
              width: "100%",
              padding: "16px",
              fontSize: 16,
              border: "2px solid #e5e7eb",
              borderRadius: 12,
              background: "#f9fafb",
              resize: "none",
              fontFamily: "inherit",
              transition: "all 0.2s",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#667eea";
              e.target.style.background = "#fff";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e5e7eb";
              e.target.style.background = "#f9fafb";
            }}
          />
          <div style={{
            fontSize: 12,
            color: "#6b7280",
            marginTop: 4,
            textAlign: "right"
          }}>
            {newGuild.intro.length}/500
          </div>
        </div>

        {/* 해시태그 */}
        <div style={{ marginBottom: 32 }}>
          <label style={{
            display: "block",
            fontSize: 16,
            fontWeight: 600,
            color: "#374151",
            marginBottom: 8
          }}>
            해시태그 (최대 10개)
          </label>
          <p style={{
            fontSize: 14,
            color: "#6b7280",
            margin: "0 0 12px 0"
          }}>
            길드의 특성을 나타내는 태그를 추가하여 멤버들이 쉽게 찾을 수 있도록 하세요
          </p>

          {/* 현재 해시태그들 */}
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 12,
            minHeight: newGuild.hashtags.length > 0 ? "auto" : 20
          }}>
            {newGuild.hashtags.map((tag, index) => (
              <span
                key={index}
                style={{
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  color: "#fff",
                  padding: "6px 12px",
                  borderRadius: 16,
                  fontSize: 12,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 6
                }}
              >
                #{tag}
                <button
                  onClick={() => removeHashtag(tag)}
                  style={{
                    background: "rgba(255,255,255,0.3)",
                    border: "none",
                    borderRadius: "50%",
                    width: 16,
                    height: 16,
                    color: "#fff",
                    fontSize: 10,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>

          {/* 해시태그 입력 */}
          {newGuild.hashtags.length < 10 && (
            <div style={{ position: "relative" }}>
              <input
                type="text"
                value={currentHashtag}
                onChange={(e) => {
                  setCurrentHashtag(e.target.value);
                  setShowSuggestions(e.target.value.length > 0);
                }}
                onKeyDown={handleHashtagInput}
                onFocus={(e) => {
                  setShowSuggestions(currentHashtag.length > 0);
                  e.target.style.borderColor = "#667eea";
                  e.target.style.background = "#fff";
                }}
                onBlur={(e) => {
                  setTimeout(() => setShowSuggestions(false), 200);
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.background = "#f9fafb";
                }}
                placeholder="해시태그를 입력하고 Enter를 누르세요"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: 14,
                  border: "2px solid #e5e7eb",
                  borderRadius: 8,
                  background: "#f9fafb",
                  transition: "all 0.2s",
                  boxSizing: "border-box"
                }}
              />

              {/* 추천 해시태그 */}
              {showSuggestions && filteredSuggestions.length > 0 && (
                <div style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "2px solid #e5e7eb",
                  borderTop: "none",
                  borderRadius: "0 0 8px 8px",
                  maxHeight: 200,
                  overflowY: "auto",
                  zIndex: 10,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                }}>
                  {filteredSuggestions.map((tag, index) => (
                    <button
                      key={index}
                      onClick={() => addHashtag(tag)}
                      style={{
                        width: "100%",
                        padding: "8px 16px",
                        border: "none",
                        background: "transparent",
                        textAlign: "left",
                        fontSize: 14,
                        color: "#374151",
                        cursor: "pointer",
                        transition: "background 0.2s"
                      }}
                      onMouseOver={(e) => e.target.style.background = "#f3f4f6"}
                      onMouseOut={(e) => e.target.style.background = "transparent"}
                    >
                      #{tag}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* 추천 해시태그 미리보기 */}
          {newGuild.hashtags.length < 10 && !showSuggestions && (
            <div style={{ marginTop: 12 }}>
              <p style={{
                fontSize: 12,
                color: "#6b7280",
                margin: "0 0 8px 0"
              }}>
                💡 추천 해시태그:
              </p>
              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 6
              }}>
                {SUGGESTED_HASHTAGS.filter(tag => !newGuild.hashtags.includes(tag)).slice(0, 8).map((tag, index) => (
                  <button
                    key={index}
                    onClick={() => addHashtag(tag)}
                    style={{
                      background: "#f1f5f9",
                      border: "1px solid #e2e8f0",
                      borderRadius: 16,
                      padding: "4px 8px",
                      fontSize: 12,
                      color: "#64748b",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = "#667eea";
                      e.target.style.color = "#fff";
                      e.target.style.borderColor = "#667eea";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = "#f1f5f9";
                      e.target.style.color = "#64748b";
                      e.target.style.borderColor = "#e2e8f0";
                    }}
                  >
                    #{tag}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* 버튼 */}
        <div style={{
          display: "flex",
          gap: 12,
          justifyContent: "flex-end"
        }}>
          <button
            onClick={() => setCreating(false)}
            disabled={uploading}
            style={{
              padding: "14px 24px",
              border: "2px solid #e5e7eb",
              borderRadius: 12,
              background: "#f9fafb",
              color: "#6b7280",
              fontSize: 16,
              fontWeight: 600,
              cursor: uploading ? "not-allowed" : "pointer",
              transition: "all 0.2s",
              opacity: uploading ? 0.6 : 1
            }}
            onMouseOver={(e) => {
              if (!uploading) {
                e.target.style.background = "#f3f4f6";
                e.target.style.borderColor = "#d1d5db";
              }
            }}
            onMouseOut={(e) => {
              if (!uploading) {
                e.target.style.background = "#f9fafb";
                e.target.style.borderColor = "#e5e7eb";
              }
            }}
          >
            취소
          </button>
          <button
            onClick={handleCreateGuild}
            disabled={uploading || !newGuild.name.trim() || !newGuild.selectedDefaultLogo}
            style={{
              padding: "14px 32px",
              border: "none",
              borderRadius: 12,
              background: uploading || !newGuild.name.trim() || !newGuild.selectedDefaultLogo 
                ? "#d1d5db" 
                : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              fontSize: 16,
              fontWeight: 700,
              cursor: uploading || !newGuild.name.trim() || !newGuild.selectedDefaultLogo ? "not-allowed" : "pointer",
              transition: "all 0.3s",
              display: "flex",
              alignItems: "center",
              gap: 8,
              boxShadow: uploading || !newGuild.name.trim() || !newGuild.selectedDefaultLogo 
                ? "none" 
                : "0 4px 12px rgba(102, 126, 234, 0.4)"
            }}
            onMouseOver={(e) => {
              if (!uploading && newGuild.name.trim() && newGuild.selectedDefaultLogo) {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 8px 20px rgba(102, 126, 234, 0.6)";
              }
            }}
            onMouseOut={(e) => {
              if (!uploading && newGuild.name.trim() && newGuild.selectedDefaultLogo) {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.4)";
              }
            }}
          >
            {uploading ? (
              <>
                <div style={{
                  width: 16,
                  height: 16,
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderTop: "2px solid #fff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite"
                }} />
                생성 중...
              </>
            ) : (
              <>
                🏰 길드 만들기
              </>
            )}
          </button>
        </div>
      </div>

      {/* 스피너 애니메이션 */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @media (max-width: 768px) {
          .guild-creation-modal {
            margin: 10px;
            padding: 24px;
            maxHeight: 95vh;
          }
          
          .default-logos-grid {
            gridTemplateColumns: repeat(auto-fit, minmax(60px, 1fr));
            gap: 8px;
          }
          
          .default-logo-button {
            width: 60px;
            height: 60px;
            fontSize: 24px;
          }
          
          .hashtag-suggestions {
            maxHeight: 150px;
          }
        }
      `}</style>
    </div>
  );
}

export default GuildCreation;